/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Buyer_Remote_HintInputs */

const vi_einvoice_buyer_remote_hint = /** @type {(inputs: Einvoice_Buyer_Remote_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bản nháp này đang lưu trên MISA. Sửa người mua tại MISA, rồi bấm Lấy lại nháp từ MISA để kiểm tra.`)
};

/**

* @param {Einvoice_Buyer_Remote_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_buyer_remote_hint = /** @type {((inputs?: Einvoice_Buyer_Remote_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Buyer_Remote_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_buyer_remote_hint(inputs)
});